var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"card-text-alignment"}},[_c('TrendyolProductSearch'),_c('Pagination',{attrs:{"pagination":_vm._pagination},on:{"pageClick":_vm.getAll}}),_c('TrendyolProductItems')],1)}
var staticRenderFns = []

export { render, staticRenderFns }